<div class="rs-panel-flex">
  <div class="rs-panel-flex-cell rs-bg-grey1">
    <h3 class="rs-tit6">{{ 'change.password.component.title' | translate }}</h3>
    <p>{{ 'change.password.component.description' | translate }}</p>
    <div class="panel">
      <px-alert
        *ngIf="alerts$ | async"
        [alerts]="alerts$ | async"
        (onCloseAlert)="onCloseAlert($event)"
      ></px-alert>
      <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()">
        <div class="row">
          <div class="small-12 columns end" #pxPassword>
            <px-password
              [componentWidthStyleClass]="'small-12 columns end'"
              [showNotIdenticalErrorOnChange]="true"
              (onPasswordFormStatusAndValue)="onPasswordFormStatusAndValue($event)"
              [customLengthValidation]="customLengthValidation"
              [resetForm]="resetPasswordFields"
            ></px-password>
          </div>
        </div>

        <button
          type="submit"
          class="rs-btn"
          [disabled]="!changePasswordForm.valid"
          [pxAnalyticsElementClicked]="{
            event_detail: 'changePassword',
            event_location: 'myWebMail.manage',
            event_action: 'click'
          }"
          [ngStyle]="{
            'pointer-events': !changePasswordForm.valid ? 'none' : 'auto',
            cursor: showLoadingSpinner ? 'not-allowed' : 'auto'
          }"
        >
          {{ 'change.password.button.title' | translate }}
        </button>
      </form>
    </div>
  </div>
</div>
